import { Component, ViewEncapsulation, ChangeDetectorRef, ViewChild, OnDestroy } from '@angular/core';
import { Subscription } from 'rxjs';
import * as _ from 'lodash';
import { SelectEvent, TabStripTabComponent } from '@progress/kendo-angular-layout';
import { GlobalsService } from '@app/cp/shared/services/globals.service';
import { DQOIReferenceDataQuery } from '@app/cp/dqoi/state/dqoi-reference-data.query';
import { UntypedFormGroup, UntypedFormControl, Validators } from '@angular/forms';
import { ConstructionService } from '@app/cp/shared/services/construction.service';
import { AdditionalCnstJobData } from '@app/cp/shared/models/AdditionalCnstJobData';
import { DQOIService } from '@app/cp/shared/services/DQOI.service';
import { DispatchesService } from '@app/cp/shared/services/dispatches.service';
import { BaseDQOIComponent } from '@app/cp/shared/base-components/base-dqoi.component';
import { SearchTarget } from '@app/cp/shared/enums/SearchTarget';
import { SaveMode } from '@app/cp/shared/enums/SaveMode';
import { CnstJobBus } from '@app/cp/shared/models/CnstJobBus';
import { CnstContractBus } from '@app/cp/shared/models/CnstContractBus';
import { RelatedJobBus } from '@app/cp/shared/models/RelatedJobBus';
import { BaseMessageInfo } from '@app/cp/shared/models/BaseMessageInfo';
import { DQOIItem } from '@app/cp/shared/models/DQOIItem';
import { GItem } from '@app/cp/shared/models/GItem';
import { CnstJobPage } from '@app/cp/shared/models/CnstJobPage';
import { DateFunctions } from '@app/cp/shared/static/date-functions';
import { CommonFunctions } from '@app/cp/shared/static/common-functions';
import { CnstJobSaveParam } from '@app/cp/shared/models/CnstJobSaveParam';
import { DispatchNotesComponent } from '@app/cp/dispatches/dispatch-notes/dispatch-notes.component';
import { WorkOrderAttachmentsComponent } from '@app/cp/dispatches/attachments/workorder-attachments.component';
import { DispatchEquipSvcdComponent } from '@app/cp/dispatches/equipment/serviced/dispatch-equip-svcd.component';
import { DispatchPartsRequestedComponent } from '@app/cp/dispatches/parts/requested/dispatch-parts-requested.component';
import { DispatchLaborComponent } from '@app/cp/dispatches/labor/dispatch-labor.component';
import { CnstMessageInfo } from '@app/cp/shared/models/CnstMessageInfo';
import { CommonValues } from '@app/cp/shared/static/CommonValues';
import { GGItem } from '@app/cp/shared/models/GGItem';
import { MasterJobList } from '@app/cp/shared/models/MasterJobList';
import { GroupResult, groupBy } from '@progress/kendo-data-query';
import { DQOIMessageInfo } from '@app/cp/shared/models/DQOIMessageInfo';
import { InvoiceMessageInfo } from '@app/cp/shared/models/InvoiceMessageInfo';
import { DQOIParam } from '@app/cp/shared/models/DQOIParam';
import { DispatchItemBus } from '@app/cp/shared/models/DispatchItemBus';
import { MessageType } from '@app/cp/shared/enums/MessageType';
import { WindowContents } from '@app/cp/shared/enums/windowContents';
import { ScheduleDispatchesComponent } from '@app/cp/dispatches/scheduled/schedule-dispatches.component';
import { CommonParam } from '@app/cp/shared/models/CommonParam';
import { DispatchAssignmentsComponent } from '@app/cp/dispatches/assignments/dispatch-assignments.component';
import { DbTable } from '@app/cp/shared/enums/DbTable';
import { CPSearchComponent } from '../../shared/search/cp-search/cp-search.component';
import { CRUDActions } from '@app/cp/shared/enums/CRUDActions';
import { Message } from '@app/cp/shared/models/message';
import { ConfirmOutput } from '@app/cp/shared/models/ConfirmOutput';
import { CPDialogResult } from '@app/cp/shared/enums/CPDialogResult';
import { AppCategory } from '@app/cp/shared/enums/AppCategories';
import { InvoiceEstimateDialogComponent } from '../../invoices/invoice-estimate/invoice-estimate-dialog.component';
import { DispatchContractAdjustmentsComponent } from './dispatch-contract-adjustments/dispatch-contract-adjustments.component';
import { DispatchCostAdjustmentsComponent } from './dispatch-cost-adjustments/dispatch-cost-adjustments.component';
import { DispatchCurrentCostAdjustmentsComponent } from './dispatch-current-cost-adjustments/dispatch-current-cost-adjustments.component';
import { DispatchBtdAdjustmentsComponent } from './dispatch-btd-adjustments/dispatch-btd-adjustments.component';
import { DispatchSixzerosixAdjustmentsComponent } from './dispatch-sixzerosix-adjustments/dispatch-sixzerosix-adjustments.component';
import { Email } from '../../shared/models/Email';
import { DispatchPartsComponent } from '../../dispatches/parts/used/dispatch-parts.component';
import { ComboBoxComponent } from '@progress/kendo-angular-dropdowns';
import { RefTrackingComponent } from '@app/cp/dispatches/ref-tracking/ref-tracking.component';
import { AuthenticationService } from '@app/cp/shared/services/authentication.service';
import { FeatureFlagService } from "@app/cp/shared/services/feature-flag.service";
import { ICPLoader, UseCPLoader } from '@app/cp/shared/decorators/cploader/cploader-decorator';
import { IFeatureFlagSet, UseFeatureFlagSet } from '@app/cp/shared/decorators/featureflags/featureflagset-decorator';
import { RefreshToken } from '@app/cp/shared/models/RefreshToken';

@UseCPLoader()
@UseFeatureFlagSet()
@Component({
    selector: 'construction-jobs',
    templateUrl: './construction-jobs.component.html',
    styleUrls: ['./construction-jobs.component.scss'],
    encapsulation: ViewEncapsulation.None
})
export class ConstructionJobsComponent extends BaseDQOIComponent<CnstJobBus, DispatchesService, AdditionalCnstJobData, CnstJobPage> implements OnDestroy {
    compFeatureFlagSet: IFeatureFlagSet = this as any;
    appCode: string = "Job";
    compLoader: ICPLoader = this as any;
    quoteNumberValue: string = "";
    svc_cnst: ConstructionService;
    hasPermission: boolean = true;
    constructor(globals: GlobalsService, featureFlagService: FeatureFlagService, svc_dqoi: DQOIService, svc_data: DispatchesService, qry_rd: DQOIReferenceDataQuery, private cd: ChangeDetectorRef, svc_cnst: ConstructionService, svc_auth: AuthenticationService) {
        super(globals, featureFlagService, svc_dqoi, qry_rd);
        this.svc_data = svc_data;
        this.svc_cnst = svc_cnst;
        this.svc_auth = svc_auth;
        this.addtlDataClass = "AdditionalCnstJobData";
        this.pageData = new CnstJobPage(svc_data, null, svc_cnst, this.featureFlagService);
        this.searchTarget = SearchTarget.job;
        this.saveMode = SaveMode.all;
        this.setupCheckForm();
    }
    reduceToMinData() { }
    public svc_auth: AuthenticationService;

    currentTabTitle: string = '';

    @ViewChild("Notes") notesComp: DispatchNotesComponent;
    @ViewChild("Attachments") attachmentsComp: WorkOrderAttachmentsComponent;
    @ViewChild("Equipment") equipSvcdComp: DispatchEquipSvcdComponent;
    @ViewChild("PartsReq") partsRequestedComp: DispatchPartsRequestedComponent;
    @ViewChild("Parts") partsComp: DispatchPartsComponent;
    @ViewChild("Labor") laborComp: DispatchLaborComponent;
    @ViewChild("Assignments") assignmentsComp: DispatchAssignmentsComponent;
    @ViewChild("ScheduleDispatches") scheduleDispatchesComponent: ScheduleDispatchesComponent;
    @ViewChild('cpSearchQuotes') CpSearchQuotes: CPSearchComponent;
    @ViewChild('cpSearchDispatchs') CpSearchDispatchs: CPSearchComponent;
    @ViewChild('invoiceEstimateDialog') public invoiceEstimateDialog: InvoiceEstimateDialogComponent;
    @ViewChild('ContractAdj') public contractAdjComp: DispatchContractAdjustmentsComponent;
    @ViewChild('EstCostAdj') public costAdjComp: DispatchCostAdjustmentsComponent;
    @ViewChild('CurrCostAdj') public currCostAdjComp: DispatchCurrentCostAdjustmentsComponent;
    @ViewChild('BTDAdj') public BTDAdjComp: DispatchBtdAdjustmentsComponent;
    @ViewChild('SixZeroSixAdj') public SixZeroSixAdjComp: DispatchSixzerosixAdjustmentsComponent;
    @ViewChild("acctClass") acctClassComp: ComboBoxComponent;
    @ViewChild("refTracking") refTrackingComp: RefTrackingComponent;
    isTMRequired: boolean = false;

    public editForm: UntypedFormGroup = new UntypedFormGroup({
        'dispatchId': new UntypedFormControl(),
        'dispatchNumber': new UntypedFormControl(),
        'customerId': new UntypedFormControl('', Validators.required),
        'locationId': new UntypedFormControl('', Validators.required),
        'accountClassId': new UntypedFormControl('', Validators.required),
        'dispatchStatusId': new UntypedFormControl('', Validators.required),
        'quoteNumber': new UntypedFormControl(),
        'quoteId': new UntypedFormControl(),
        'invoiceNumber': new UntypedFormControl(),
        'receivedById': new UntypedFormControl('', Validators.required),
        'receivedDateTime': new UntypedFormControl(null, Validators.required),
        'poNumber': new UntypedFormControl(),
        'dispatchReason': new UntypedFormControl(null, Validators.required),
        'isConstruction': new UntypedFormControl(false),
        'isProgressBill': new UntypedFormControl(false),
        'foremanId': new UntypedFormControl(''), //Not required at Setup
        'contractProjAdminId': new UntypedFormControl(''),
        'contractJrProjAdminId': new UntypedFormControl(''),
        'contractProjEstId': new UntypedFormControl(),
        'relatedJobTypeId': new UntypedFormControl('', Validators.required),
        'wonumber': new UntypedFormControl(),
        'masterJobId': new UntypedFormControl(),
        'dispatchActionCodesId': new UntypedFormControl(),
        'dispatchCauseCodesId': new UntypedFormControl(),
        'dispatchFailureCodesId': new UntypedFormControl(),
        'dispatchProblemCodeId': new UntypedFormControl(),
        'refreshDate': new UntypedFormControl(),
        'insertUserId': new UntypedFormControl(),
        'insertDt': new UntypedFormControl(),
        'updateUserid': new UntypedFormControl(),
        'updateDt': new UntypedFormControl(),
        'contractNumber': new UntypedFormControl('', Validators.required),
        "quoteEstimator": new UntypedFormControl(),
        "closeOutResources": new UntypedFormControl(),
        "closeOutResourcesStatusId": new UntypedFormControl(),
        "timeMat": new UntypedFormControl(),
        "timeMatPercent": new UntypedFormControl()

    });
    setForm() {
        this.editForm.patchValue({
            dispatchId: this.data.dispatchId,
            dispatchNumber: this.data.dispatchNumber,
            customerId: this.data.customerId,
            locationId: this.data.locationId,
            accountClassId: this.data.accountClassId,
            dispatchStatusId: this.data.dispatchStatusId,
            quoteNumber: this.data.quoteNumber,
            invoiceNumber: this.data.invoiceNumber,
            receivedById: this.data.receivedById,
            receivedDateTime: this.data.receivedDateTime,
            poNumber: this.data.ponumber,
            dispatchReason: this.data.dispatchReason,
            isConstruction: this.data.isConstruction,
            isProgressBill: this.data.isProgressBill,

            foremanId: this.data.foremanId,
            contractProjAdminId: this.data.contractProjAdminId,
            contractJrProjAdminId: this.data.contractJrProjAdminId,
            contractProjEstId: this.data.contractProjEstId,
            relatedJobTypeId: this.data.relatedJobTypeId,
            wonumber: this.data.wonumber,
            masterJobId: this.data.masterJobId,
            quoteId: this.data.quoteId,
            dispatchActionCodesId: this.data.dispatchActionCodesId,
            dispatchCauseCodesId: this.data.dispatchCauseCodesId,
            dispatchFailureCodesId: this.data.dispatchFailureCodesId,
            dispatchProblemCodeId: this.data.dispatchProblemCodeId,
            refreshDate: this.data.refreshDate,
            inserDt: this.data.insertDt,
            insertUserId: this.data.insertUserId,
            updateDt: this.data.updateDt,
            updateUserId: this.data.updateUserid,
            timeMat: this.data.timeMat,
            timeMatPercent: this.data.timeMatPercent
        });
        this.setProjectManagerValidity();
    }
    get canDelete(): boolean {
        return false;
    }
    get canEdit(): boolean {
        return this.hasData && this.appSaveValidation() && !this.lockEdit && this.canEditBilledOrCanceled();
    }
    canEditBilledOrCanceled(): boolean {
        let can: boolean = true;
        if ((this.data.dispatchStatusId == CommonValues.Dispatch_Billed || this.data.dispatchStatusId == CommonValues.Dispatch_Canceled) && !this.rights.EditClosedDispatch) {
            can = false;
        }
        return can;
    }
    get childCanEdit_Notes(): boolean {
        return this.childCanEdit || (this.hasId && this.statusId === CommonValues.Dispatch_ForConstructionReview);
    }
    get isForConstructionReview(): boolean {
        return (this.statusId && this.statusId === CommonValues.Dispatch_ForConstructionReview);
    }
    get saveMode_Notes(): any {
        let saveMode = this.saveMode;
        if (this.hasData && this.hasId) {
            saveMode = SaveMode.individual;
        }
        return saveMode;
    }

    public getUserPermissions() {
        let x;
        let uid = this.globals.userId;
        this.svc_auth.userFeatures(uid).subscribe(data => {
            if (data) {
                x = data.filter(x => x.value === CommonValues.ChangeStatusFrom_ForConstructionReview)
                if (x.length > 0) {
                    this.hasPermission = true;
                } else {
                    this.hasPermission = false;
                }
            }
        });
    }

    setFormAddtl() {
        this.editForm.patchValue({
            contractNumber: this.addtlData.contractNumber,
            quoteEstimator: this.addtlData.quoteEstimator
        });

    }
    subs_getJobDefaultsFromQuote: Subscription;
    subs_checkAndSetChangeOrder: Subscription;
    subs_getContractInfoOnly: Subscription;
    relatedAccountClassIds: any[] = [];
    noMainJobForChangeOrder: boolean = false;
    mainTradeJob: boolean = false;
    readonly mainTradeJobClasses: any[] = [
        CommonValues.AccountClass_ReferHVACConstruction,	//Refer / HVAC Construction
        CommonValues.AccountClass_ElectricalConstruction,	//Electrical Construction
        CommonValues.AccountClass_CarpentryConstruction,	//Carpentry Construction
        CommonValues.AccountClass_MgmtConstruction,	//Mgmt Construction
        CommonValues.AccountClass_EMSConstruction,	//EMS Construction
        CommonValues.AccountClass_HVACConstruction,	//HVAC Construction
        CommonValues.AccountClass_GCConstruction,	//GC Construction
        CommonValues.AccountClass_EquipmentSales,	//Equipment Sales
        CommonValues.AccountClass_PlumbingConstruction,	//Plumbing Construction
        CommonValues.AccountClass_WarrantyConstruction,	//Warranty Construction
        CommonValues.AccountClass_WarrantyMFG,	//MFG Warranty Construction
        CommonValues.AccountClass_ReferService,	//Main Service Types
        CommonValues.AccountClass_HVACService,	//Main Service Types
        CommonValues.AccountClass_CarpentryService,	//Main Service Types
        CommonValues.AccountClass_ElectricalService,	//Main Service Types
        CommonValues.AccountClass_EnergyManagementServices, //EMS Service Types
        CommonValues.AccountClass_EnergyManagementServicesSub //EMS Service Types
    ];
    subs_tryCreateInvoice: Subscription;
    subs_createInvoice: Subscription;
    override ngOnDestroy() {
        super.ngOnDestroy();
        CommonFunctions.unsubscribe(this.subs_getJobDefaultsFromQuote);
        CommonFunctions.unsubscribe(this.subs_checkAndSetChangeOrder);
        CommonFunctions.unsubscribe(this.subs_getContractInfoOnly);
        CommonFunctions.unsubscribe(this.subs_tryCreateInvoice);
        CommonFunctions.unsubscribe(this.subs_createInvoice);
    }
    defaultAddtlData: AdditionalCnstJobData;
    rawMasterList: any[]; //MasterJobList[];
    setFormMaster() {
        this.editForm.patchValue({
            masterJobId: this.masterId
        });

    }
    setMasterId() {
        if (!this.hasMasterId && this.hasData && CommonFunctions.hasGuidValue(this.data.masterJobId)) {
            this._masterId = this.data.masterJobId;
        }
    }
    createNewAdditionalData(): AdditionalCnstJobData {
        var busObj: AdditionalCnstJobData = super.createNewAdditionalData();
        if (CommonFunctions.hasValue(this.defaultAddtlData)) {
            busObj = this.defaultAddtlData;
        }
        return busObj;
    }
    setNewDefaults() {
        super.setNewDefaults();

        let dqoiitem = this.svc_dqoi.getDQOIItem(this.dqoiIndex);
        //  this.addtlData.contractNumber = dqoiitem.dispatchNumber;
        if (CommonFunctions.hasValue(this.defaultAddtlData)) {
            this.data.ponumber = this.defaultAddtlData.contractPONumber;
        }
        this.data.masterJobId = this.masterId;

        this.setFormAddtl();
        if (CommonFunctions.hasValue(this.newParam)) {
            if (CommonFunctions.hasValue(this.newParam.dcParams.RelatedJobTypeId)) {
                this.data.relatedJobTypeId = this.newParam.dcParams.RelatedJobTypeId;
                //this.newParam = null;
            }
        }
    }

    refreshMessage(event: any) {
        if (this.compFeatureFlagSet.featureFlagSet[`construction-job-attachments`] && event.messageSubject && event.messageSubject.toLowerCase() === CommonValues.Construction_Include_System_Attachments) {
            this.pageData.getDispatchAttachments(this.id, event.value);
        } else {
            this.pageData.getDispatchAttachments(this.id, !this.isConstruction);
        }
    }
    refresh(): void {
        if (!this.refreshToken || this.refreshToken == 0) {
            this.refreshToken = 1;
        }
        let tempId = this.id;
        this.id = undefined;
        this.cd.detectChanges();
        this.id = tempId;

        this.getData();

        if (this.currentTabTitle === 'Invoice') {
            /* Component not yet rendered (lazy *loadOnDemand) � broadcast via service subject*/
            const token = new RefreshToken();
            token.all = true;
            this.svc_cnst.refreshSubject.next(token);
        }

        this.refreshData(null);
        this.refreshToken = 0;
    }
    get is24HoursAfterCreation(): boolean {
        let isGt24: boolean = false;
        if (this.hasId) {
            let hours: number = DateFunctions.dateDiffHours(this.data.insertDt);
            isGt24 = hours >= 24 ? true : false;
        }
        return isGt24;
    }
    get canEdit24HoursFields(): boolean {
        return !this.is24HoursAfterCreation || this.rights.ContractEditAdmin;
    }
    get statusId(): any {
        return this.editForm.value.dispatchStatusId;
    }
    get accountClassId(): any {
        return this.editForm.value.accountClassId;
    }
    get hasAccountClassId(): boolean {
        return CommonFunctions.hasGuidValue(this.accountClassId);
    }
    get isChangeOrder(): boolean {
        //let isChangeOrder = false;
        return (this.hasEditForm ? this.editForm.value.relatedJobTypeId === CommonValues.RelatedJobType_ChangeOrder ? true : false : false);
    }
    get parentContractProjEstId(): any {
        return this.hasParentJob ? this.parentJob.contractProjEstId : null;
    }
    get hasParentContractProjEstId(): boolean {
        return CommonFunctions.hasGuidValue(this.parentContractProjEstId);
    }
    get contractProjEstId(): any {
        return this.editForm.value.contractProjEstId;
    }
    get hasContractProjEstId(): boolean {
        return CommonFunctions.hasGuidValue(this.contractProjEstId);
    }
    get contractProjAdminId(): any {
        return this.hasEditForm ? this.editForm.value.contractProjAdminId : null;
    }
    get hasContractProjAdminId(): boolean {
        return CommonFunctions.hasGuidValue(this.contractProjAdminId);
    }
    get parentContractProjAdminId(): any {
        return this.hasParentJob ? this.parentJob.contractProjAdminId : null;
    }
    get hasParentContractProjAdminId(): boolean {
        return CommonFunctions.hasGuidValue(this.parentContractProjAdminId);
    }
    get parentForemanId(): any {
        return this.hasParentJob ? this.parentJob.foremanId : null;
    }
    get hasParentForemanId(): boolean {
        return CommonFunctions.hasGuidValue(this.parentForemanId);
    }
    get canEditPM(): boolean {
        return (!this.readOnly && (this.canEdit24HoursFields || this.rights.EditProjectManager));
    }
    get canEditJrPM(): boolean {
        return (!this.readOnly && (this.canEdit24HoursFields || this.rights.EditProjectManager));
    }
    get readOnlyEstimator(): boolean {
        return this.readOnly ||
            (this.isChangeOrder && this.hasContractProjEstId && this.contractProjEstId == this.parentContractProjEstId && !this.canEdit24HoursFields);
    }
    get readOnlyReceivedBy(): boolean {
        return this.readOnly || (this.data ? !this.data.isAdded : false);
    }
    get relatedJobTypeId(): any {
        return this.hasEditForm ? this.editForm.value.relatedJobTypeId : null;
    }
    get hasRelatedJobTypeId(): boolean {
        return CommonFunctions.hasValue(this.relatedJobTypeId);
    }
    get foremanId(): any {
        return this.hasEditForm ? this.editForm.value.foremanId : null;
    }
    get hasForemanId(): boolean {
        return CommonFunctions.hasGuidValue(this.foremanId);
    }
    get hasAcctClassText(): boolean {
        return this.acctClassComp && CommonFunctions.hasStringValue(this.acctClassComp.text);
    }
    get canReturnToService(): boolean {
        return this.statusId === CommonValues.Dispatch_ForConstructionReview;

    }
    get canEditChild_Notes(): boolean {
        return this.customFormValidation() && ((this.saveMode == SaveMode.individual || !this.readOnly) && ((this.canSave && this.saveMode === SaveMode.all) || this.hasId));
    }
    get canEditChild_Attachments(): boolean {
        return this.customFormValidation() && ((this.saveMode == SaveMode.individual || !this.readOnly) && (this.canSave || this.hasId));
    }
    subs_canSetJobBackToService: Subscription;
    returnToService() {
        if (this.hasPermission) {
            this.cnfShow("Are you sure you want to return this dispatch to Service?", CRUDActions.Update, null, "Return to Service", "CHSTATUS", false);
        }
    }

    confirmDialog(data: ConfirmOutput) {
        let handled: boolean = false;
        if (data.dialogResult === CPDialogResult.ok) {
            if (data.code === "CHSTATUS") {
                this.subs_canSetJobBackToService = this.svc_cnst.canSetJobBackToService(this.id).subscribe((info: BaseMessageInfo) => {
                    if (!info.saveError && CommonFunctions.hasArrayElementValue(info.primaryReturn)) {
                        let result: GGItem = info.primaryReturn[0] as GGItem;
                        if (result.value) {
                            if (result.value === 1) {
                                this.editForm.value['contractNumber'] = null;
                                this.editForm.value['relatedJobTypeId'] = null;
                            } else {
                                this.editForm.value['contractNumber'] = null;
                                this.editForm.value['relatedJobTypeId'] = null;
                                this.editForm.value['accountClassId'] = null;
                            }
                        }
                        this.data.setJobBackToService = true;
                        this.saveAll();
                    }
                });
            }
        }
        if (!handled) {
            this.confirmCustom(data);
        }

    }

    viewInvoiceEstimate() {

        this.invoiceEstimateDialog.show(this.id, SearchTarget.job);

    }
    customFormValidation() {
        var okToSave: boolean = true;
        if (this.showProjectMgr) {
            okToSave = this.hasContractProjAdminId;
        }
        if (!this.editForm.value.masterJobId || !this.hasAcctClassText) {
            okToSave = false;
        }
        if (this.noMainJobForChangeOrder) {
            okToSave = false;
        }
        return okToSave;
    }
    get canCreateInvoice(): boolean {
        let canCreate: boolean = false;
        if (this.hasId && this.hasRelatedJobTypeId) {
            canCreate = this.relatedJobTypeId === CommonValues.RelatedJobType_ManufacturerWarrantyCarpentry
                || this.relatedJobTypeId === CommonValues.RelatedJobType_ManufacturerWarrantyElectrical
                || this.relatedJobTypeId === CommonValues.RelatedJobType_ManufacturerWarrantyRefrigeration
                || this.relatedJobTypeId === CommonValues.RelatedJobType_PostWarranty;
        }
        return canCreate;
    }
    get canEstimateInvoice(): boolean {
        let can: boolean = this.canCreateInvoice || (this.hasId && this.statusId == CommonValues.Dispatch_ForConstructionReview);
        return can;
    }
    createNew(busObj: CnstJobBus) {
        let newBusObj: CnstJobBus = new CnstJobBus(busObj);
        return newBusObj;
    }
    setCustomerLocation(customerId: any, locationId: any) {
        this.data.customerId = customerId;
        this.data.locationId = locationId;
        super.setCustomerLocation(customerId, locationId);
    }
    protected setNoData(item: DQOIItem) {
        if (CommonFunctions.hasValue(item)) {
            if (!CommonFunctions.hasNumberValue(this.dqoiIndex)) {
                this.dqoiIndex = item.index;
            }
            super.setNoData(item);
            this._masterId = item.masterJobId ? item.masterJobId : item.dispatchId;
            this.setFormMaster();
            this.new();
            this.getListFromMaster();
        }
    }

    getListFromMaster() {
        this.masterListLoader = true;
        CommonFunctions.unsubscribe(this.subs_masterList);
        this.subs_masterList = this.svc_cnst.getContractJobs(this.masterId).subscribe((info: BaseMessageInfo) => {
            let arr = [];
            for (let i = 0; i < info.primaryReturn.length; i++) {
                let busObj: MasterJobList = new MasterJobList(info.primaryReturn[i]);
                arr.push(busObj);
            }
            this.rawMasterList = arr;
            let grpmasterList: GroupResult[] = groupBy(this.rawMasterList, [{ field: "relatedJobType" }])
            this.masterList = grpmasterList;
            this.cloneMasterList();
            this.masterListLoader = false;
        });
    }
    cloneMasterList() {
        this.masterListAll = _.cloneDeep(this.rawMasterList);
    }
    getData() {
        if (this.id === null || this.id === undefined) {
            return;
        }
        //   super.getData(); was only calling getAddtlData() - moved to after super.setdata() in setData()
        this.mainLoadingOn(true, this.compLoader);
        CommonFunctions.unsubscribe(this.subs_data);

        this.subs_data = this.svc_cnst.getConstJob(this.id).subscribe((info: BaseMessageInfo) => {
            let dataObj: CnstJobBus = new CnstJobBus(info.primaryReturn);
            this.setData(dataObj);

            this.mainLoadingOff(true, this.compLoader);
        });
        //CommonFunctions.unsubscribe(this.subs_dataAddInfo);
    }
    getAddtlData() {
        let tempJobId: any = CommonFunctions.hasGuidValue(this.id) ? this.id : CommonValues.Guid_Empty;
        let tempMasterId: any = CommonFunctions.hasGuidValue(this.masterId) ? this.masterId : CommonValues.Guid_Empty;
        console.log("job-getadddata-a: ", this.id, tempJobId, tempMasterId);
        CommonFunctions.unsubscribe(this.subs_dataAddInfo);
        if (this.compFeatureFlagSet.featureFlagSet['construction-job-attachments']) {
            this.pageData.getDispatchAttachments(this.id, !this.isConstruction);
        } else {
            this.pageData.getDispatchAttachments(this.id, true);
        }
        this.subs_dataAddInfo = this.svc_cnst.getAdditionalJobData(tempJobId, tempMasterId).subscribe(data => {
            console.log("job-getadddata: ", this.id, data);
            this.addtlData = new AdditionalCnstJobData(data);
            if (!CommonFunctions.hasGuidValue(this.id)) {
                this.defaultAddtlData = _.cloneDeep(this.addtlData);
            }
            this.setFormAddtl();
        });
    }
    clear() {
        this.parentJob = null;
        super.clear();
    }
    protected clearAddtlData() {
        this.addtlData = _.cloneDeep(this.defaultAddtlData)
    }
    setData(data: CnstJobBus) {
        this.customerChanged(data.customerId);
        this.locationChanged(data.locationId);
        super.setData(data);
        console.log("job-data: ", this.data);
        this.getAddtlData();
        this.getRelatedAccountClassIds();
        this.getUserPermissions();
        //        this.refreshData(null);
        this.readOnly = false;
    }

    //get masterId(): any {
    //    return this.hasData ? this.data.masterJobId : null;
    //}
    afterDataSet() {
        if (this.hasId) {
            this.pageData.getSubcoOrderDetail(this.id);
        }
    }
    protected resetData(dqoiItem: DQOIItem) {
        super.resetData(dqoiItem);
        if (CommonFunctions.hasValue(dqoiItem) && (dqoiItem.hasDispatchId || dqoiItem.hasJobId)) {
            this.id = dqoiItem.hasJob ? dqoiItem.jobId : dqoiItem.dispatchId;
            this.getData();
        }
    }
    setDQOIState() {

        if (CommonFunctions.hasValue(this.dqoiIndex) && this.dqoiIndex > 0) {
            let item: DQOIItem = this.svc_dqoi.getDQOIItem(this.dqoiIndex);
            //if (!CommonFunctions.hasGuidValue(item.jobId)) {

            item.jobId = this.data.dispatchId;
            item.jobNumber = this.data.dispatchNumber;
            if (CommonFunctions.hasGuidValue(this.masterId) && !CommonFunctions.hasGuidValue(item.masterJobId)) {
                item.masterJobId = this.masterId;
                item.dispatchId = this.masterId;
            }
            item.dispatchAccountClassId = this.data.accountClassId;
            if (!this.settingFromDQOIState) {
                if (!this.hasMasterId) {
                    item.customerId = this.data.customerId;
                    item.locationId = this.data.locationId;
                }
                else {
                    //Added this when create job from quote and saved.
                    //I added the setmasterid earlier now this
                    //so that now when I click contract it shows up
                    //not sure if there is a better way - maybe do this part in setmasterid
                    if (!item.hasContract) {
                        item.dispatchId = this.masterId;
                    }
                }
                item.quoteId = this.data.quoteId;
                this.setCommon(item);
            }
            this.svc_dqoi.setDQOIItem(item);
        }
    }
    protected setCommon(dqoiItem: DQOIItem) { }
    onTabSelect(e: SelectEvent) {

        this.currentTabTitle = e.title;

        if (e.title === 'Serviced Equipment' && !this.pageData.hasEquipmentSvcd) {
            this.pageData.getData(this.data.dispatchId, 'SVCDEQUIP');

        }
        else if (e.title === 'Status History' && !this.pageData.hasStatusHist) {
            this.pageData.getStatusHistory(this.data.dispatchId);
        }
        else if (e.title === 'Assets' && !this.pageData.hasAssets) {
            this.pageData.getAssets(this.data.dispatchId);
        }
        else if (e.title === 'Notes' && !this.pageData.hasNotes) {
            this.pageData.getNotes(this.data.dispatchId);
        }
        else if (e.title === 'Assignments' && !this.pageData.hasAssignments) {
            this.pageData.getAssignments(this.data.dispatchId, this.referenceData);
        }
        else if (e.title === 'Assignment History' && !this.pageData.hasAssignments) {
            this.pageData.getAssignments(this.data.dispatchId, this.referenceData);
        }
        else if (e.title === 'Labor' && !this.pageData.hasLabor) {
            this.pageData.getLabor(this.data.dispatchId);
        }
        else if (e.title === 'Parts Requested' && !this.pageData.hasPartsRequested) {
            this.pageData.getPartsRequested(this.data.dispatchId);
        }
        else if (e.title === 'Parts Ordered' && !this.pageData.hasPartsOrdered) {
            this.pageData.getPartsOrdered(this.data.dispatchId);
        }
        else if (e.title === 'Parts Used' && !this.pageData.hasParts) {
            if (!this.pageData.hasAssignments) {
                this.pageData.getAssignments(this.data.dispatchId, this.referenceData);
            }

            this.pageData.getParts(this.data.dispatchId, this.referenceData);
        }
        else if (e.title === 'Attachments' && !this.pageData.hasAttachments) {
            if (this.compFeatureFlagSet.featureFlagSet['construction-job-attachments']) {
                this.pageData.getDispatchAttachments(this.data.dispatchId, !this.isConstruction);
            } else {
                this.pageData.getDispatchAttachments(this.data.dispatchId, true);
            }
        }
        else if (e.title === 'SUB-PO' && !this.pageData.hasAssets) {
            this.pageData.getSubcoOrderDetail(this.data.dispatchId);
        }
        else if (e.title === 'Contract Adj.' && !this.pageData.hasDispatchContAdjustments) {
            this.pageData.getDispatchContAdjustments(this.data.dispatchId);
        }
        else if (e.title === 'Est. Cost Adj.' && !this.pageData.hasDispatchCostAdjustments) {
            this.pageData.getDispatchCostAdjustments(this.data.dispatchId);
        }
        else if (e.title === 'Curr. Cost Adj.' && !this.pageData.hasDispatchCurrCostAdjustments) {
            this.pageData.getDispatchCurrCostAdjustments(this.data.dispatchId);
        }
        else if (e.title === 'BTD Adj.' && !this.pageData.hasDispatchBTDAdjustments) {
            this.pageData.getDispatchBTDAdjustments(this.data.dispatchId);
        }
        else if (e.title === '606 Status' && !this.pageData.hasSixZeroSixAdjustments) {
            this.pageData.getDispatchSixZeroSixAdjustments(this.data.dispatchId);
        }
        //else Status History
    }
    saveAll() {
        let now: Date = DateFunctions.getDateNow();
        let busObj: CnstJobSaveParam = new CnstJobSaveParam(this.data);
        busObj.setFromForm(this.editForm.value);
        busObj.setCommon(this.globals.userId, now, this.globals.companyId);
        busObj.setBeforeSave();

        if (CommonFunctions.hasValue(this.notesComp)) {
            busObj.notes = _.cloneDeep(this.notesComp.getChanged());
            busObj.addDeletedItems(this.notesComp.getDeletedItems());
        }
        if (CommonFunctions.hasValue(this.attachmentsComp)) {
            busObj.attachments = _.cloneDeep(this.attachmentsComp.getChanged());
            busObj.addDeletedItems(this.attachmentsComp.getDeletedItems());
        }
        if (CommonFunctions.hasValue(this.equipSvcdComp)) {
            busObj.equipment = _.cloneDeep(this.equipSvcdComp.getChanged());
            busObj.addDeletedItems(this.equipSvcdComp.getDeletedItems());
        }
        if (CommonFunctions.hasValue(this.partsRequestedComp)) {
            busObj.partsReq = _.cloneDeep(this.partsRequestedComp.getChanged());
            busObj.addDeletedItems(this.partsRequestedComp.getDeletedItems());
        }
        if (CommonFunctions.hasValue(this.partsComp)) {
            busObj.parts = _.cloneDeep(this.partsComp.getChanged());
            busObj.addDeletedItems(this.partsComp.getDeletedItems());
        }
        if (CommonFunctions.hasValue(this.laborComp)) {
            busObj.labor = _.cloneDeep(this.laborComp.getChanged());
            busObj.addDeletedItems(this.laborComp.getDeletedItems());
        }
        if (CommonFunctions.hasValue(this.assignmentsComp)) {
            busObj.assignments = _.cloneDeep(this.assignmentsComp.getChanged());
            busObj.addDeletedItems(this.assignmentsComp.getDeletedItems());
        }
        if (CommonFunctions.hasValue(this.contractAdjComp)) {
            busObj.contAdjustments = _.cloneDeep(this.contractAdjComp.getChanged());
        }
        if (CommonFunctions.hasValue(this.costAdjComp)) {
            busObj.costAdjustments = _.cloneDeep(this.costAdjComp.getChanged());
        }
        if (CommonFunctions.hasValue(this.currCostAdjComp)) {
            busObj.currCostAdjustments = _.cloneDeep(this.currCostAdjComp.getChanged());
        }
        if (CommonFunctions.hasValue(this.BTDAdjComp)) {
            busObj.btdAdjustments = _.cloneDeep(this.BTDAdjComp.getChanged());
        }
        if (CommonFunctions.hasValue(this.SixZeroSixAdjComp)) {
            busObj.sixZeroSixAdjustments = _.cloneDeep(this.SixZeroSixAdjComp.getChanged());
        }
        if (CommonFunctions.hasValue(this.refTrackingComp)) {
            busObj.refTracking = _.cloneDeep(this.refTrackingComp.getChanged());
            busObj.addDeletedItems(this.refTrackingComp.getDeletedItems());
        }
        //////   busObj.billingGeographyInfo = null;
        //////   busObj.shippingGeographyInfo = null;
        console.log("job-sa: ", busObj);
        ////busObj.deletedItems
        this.mainLoadingOn(true, this.compLoader);
        CommonFunctions.unsubscribe(this.subs_save);
        this.subs_save = this.svc_cnst.jobSaveAll(busObj).subscribe((info: CnstMessageInfo) => {
            if (!info.saveError) {

                this.resetMasterList = true;
                //  let dataObj: InvoiceBus = new InvoiceBus(info.invoice);
                if (this.data.setJobBackToService === true) {
                    this.globals.notifySuccess("The Job Was Successfully Configured back to Service");
                    this.clear();
                }
                else {
                    if (info.dqoiItem) {
                        console.log("job-save-all-agd-b: ", info.dqoiItem, info.dqoiItem.index, this.dqoiIndex);
                        info.dqoiItem.index = this.dqoiIndex;
                        this.resetDQOIItem(info.dqoiItem);
                    }
                    this.saveSuccess();
                    this.clear();
                    this.data = new CnstJobBus(info.job);
                    //                this.setData(dataObj);
                    this.sendRefreshMessage(SearchTarget.contract, AppCategory.None);
                    this.getDataFromId(info.job.dispatchId);
                    if (CommonFunctions.hasValue(this.afterSaveMessage)) {
                        let msg = _.cloneDeep(this.afterSaveMessage);
                        console.log("disp-saveall-as: ", msg);
                        this.setAfterSaveMessage(null);
                        this.parentMessage(msg, this.compLoader);
                        if (this.compFeatureFlagSet.featureFlagSet['construction-job-attachments']) {
                            this.pageData.getDispatchAttachments(this.data.dispatchId, !this.isConstruction);
                        } else {
                            this.pageData.getDispatchAttachments(this.data.dispatchId, true);
                        }
                    }
                }
            }
            else {
                this.saveError(info.message);
            }
            this.mainLoadingOff(true, this.compLoader);
        });
    }
    resetDQOIItem(itemData: DQOIItem) {

        let itemBus: DQOIItem = new DQOIItem(itemData);
        //Below line commented out for CP-1498. I think this is vestigial code that is no longer needed
        //this.svc_dqoi.setDQOIItem(itemBus);
    }
    delete() {
        if (this.data.isAdded) {
            this.clear();
        }
        else {
            CommonFunctions.unsubscribe(this.subs_delete);
            this.subs_delete = this.svc_data.deleteDispatch(this.id).subscribe((info: BaseMessageInfo) => {
                if (!info.saveError) {
                    this.deleteSuccess();
                    this.clear();
                }
                else {
                    this.deleteError(info.message)
                }
            });
        }
    }
    setup(data: any, code: string = null) {
        if (code === "NEWCHANGEORDER") {
            this.newParam = new CommonParam();
            this.newParam.addParam("RelatedJobTypeId", CommonValues.RelatedJobType_ChangeOrder);
            this.checkChange(this.dqoiIndex, SearchTarget.job, this.compFeatureFlagSet.featureFlagSet["construction-add-new-change-order"] ? true : false);
            this.new();
        }
        else if (code === "GOTO") {
            this.clear();
            this.checkChange(this.dqoiIndex, SearchTarget.job, false);
            this.setPristine();
            this.getDataFromId(data.id);
        }
        else if (code === "CRFROMBID") {
            let dqoiParam: DQOIParam = data as DQOIParam;
            dqoiParam.dqoiItem.invoiceNumber = null;
            this.dqoiIndex = dqoiParam.dqoiItem.index;
            dqoiParam.dqoiItem.jobAdded = true;
            this.svc_dqoi.setDQOIItem(dqoiParam.dqoiItem);

            let info: CnstMessageInfo = dqoiParam.data as CnstMessageInfo;
            if (info.warning) {
                this.miShow("Please Review and Correct/Acknowledge the list of Messages", info, info.job, "Warning Creating Job", "CRFROMBID");
                //                this.notify(info.message, "W", true);
            }
            this.clear();
            //this.editForm.patchValue({
            //    receivedDataTime: DateFunctions.getDateNow()
            //});
            let locationId: any = info.job.locationId;
            this.customerChanged(info.job.customerId);
            this.locationChanged(locationId);
            this.setData(info.job);
            this.addtlData = new AdditionalCnstJobData(info.dcValues.addtlData);
            this.pageData = new CnstJobPage(this.svc_data, null, this.svc_cnst, this.featureFlagService);
            this.pageData.setPartsRequested(info.dcValues.PartsReq);
            this.setFormAddtl();
            this.edit();
            this.setDirty();
        }
    }
    filterMasterList(value) {
        if (!value) {
            return;
        }
        let list: any[] = this.masterListAll?.filter((s) => s.description.toLowerCase().indexOf(value.toLowerCase()) !== -1) ?? [];
        let grpmasterList: GroupResult[] = groupBy(list, [{ field: "category" }])
        this.masterList = grpmasterList;

    }

    contractSearch: boolean = false;
    doContractSearch(e: any) {
        if (CommonFunctions.hasStringValue(e) && e === "CLEAR") {

            //   this.editForm.value.masterJobId = null;
            this.editForm.patchValue({
                contractNumber: null,
                masterJobId: null
            });
            //            this.cpQuoteSelected({ DispatchNumber: "", DispatchId: null });
        }
        else {
            this.contractSearch = true;
            this.CpSearchDispatchs.setSearchText(e);
        }
    }
    contractSelected(value: any) {
        this.contractSearch = false;
        if (value != null) {
            //this.editForm.controls["dispatchNumber"].setValue(value.DispatchNumber);

            this.editForm.patchValue({
                contractNumber: value.DispatchNumber,
                masterJobId: value.DispatchId
            });
        }
    }
    contractValidationError(event: any) {

        this.contractSearch = true;
    }
    contractValidate(value: any) {

        var skipCheck = false;
        if (!value) {

            this.editForm.patchValue({
                contractNumber: value,
                masterJobId: null
            });
            skipCheck = true;
        }
        else {
            var masterJobId = this.editForm.controls["masterJobId"].value;
            var contractNumber = this.editForm.controls["contractNumber"].value;
            if (masterJobId) {
                if (contractNumber === value) { skipCheck = true }
            }
        }

        if (!skipCheck) {
            this.contractSearch = false;
            this.CpSearchDispatchs.validate(value);
        }

    }
    get showActionOnContract(): boolean {
        return !this.hasMasterId && this.hasAcctClassText && this.hasEditForm && this.editForm.valid && (!this.showProjectMgr || this.hasContractProjAdminId);
        //return this.hasQuoteId ? this.rights.ViewQuotes : this.rights.MaintainQuotes;
    }
    get availableAccountClasses(): GGItem[] {
        return (this.statusId == CommonValues.Dispatch_ForConstructionReview && this.referenceData) ? this.referenceData.accountClasses : this.referenceData.accountClassesConstruction;
    }
    //if(this.showProjectMgr) {
    //    okToSave = this.hasContractProjAdminId;
    //}

    cpContractAction(number: string) {
        console.log("job-cpContractAction", this.data, this.id, this.data.masterJobId, this.editForm.value, this.acctClassComp);
        if (!CommonFunctions.hasGuidValue(this.data.masterJobId)) {
            let now: Date = DateFunctions.getDateNow();
            let busObj: CnstJobSaveParam = new CnstJobSaveParam(this.data);
            busObj.setFromForm(this.editForm.value);
            busObj.setCommon(this.globals.userId, now, this.globals.companyId);
            this.goTo(busObj, SearchTarget.contract, "CRFROMSVCJOB")
        }
    }
    itemDisabled(itemArgs: { dataItem: any, index: any; }) {
        return !itemArgs.dataItem.canSelect;
    }
    disableOnHold(itemArgs: { dataItem: any, index: any; }) {
        return false;
    }
    get hasQuoteId(): boolean {
        return this.hasData && CommonFunctions.hasGuidValue(this.data.quoteId) ? true : false;
    }
    cpQuoteGoto(number: string) {

        if (!CommonFunctions.hasGuidValue(this.data.quoteId)) {

            this.goTo(this.id, SearchTarget.quote, "CRFROMJOB")
        }
        else {
            this.goTo(this.data.quoteId, SearchTarget.quote);
        }
    }
    cpQuoteValidationError(event: any) {

        this.cpQuoteSearch = true;
    }
    cpQuoteSearch: boolean = false;
    doQuoteSearch(e: any) {
        if (CommonFunctions.hasStringValue(e) && e === "CLEAR") {
            this.cpQuoteSelected({ QuoteNumber: "", QuoteId: null });
        }
        else {
            this.cpQuoteSearch = true;
            this.quoteNumberValue = "";
            this.CpSearchQuotes.setSearchText(e);

        }
    }
    cpQuoteSelected(value: any) {
        this.cpQuoteSearch = false;
        if (value != null) {
            //this.editForm.controls["dispatchNumber"].setValue(value.DispatchNumber);
            //           if (this.quoteNumberValue === value.QuoteNumber || this.quoteNumberValue === "") {

            this.editForm.patchValue({
                quoteNumber: value.QuoteNumber,
                quoteId: value.QuoteId
            });
            CommonFunctions.unsubscribe(this.subs_getJobDefaultsFromQuote);
            this.subs_getJobDefaultsFromQuote = this.svc_cnst.getJobDefaultsFromQuote(value.QuoteId).subscribe((info: BaseMessageInfo) => {
                if (!info.saveError) {
                    this.addtlData.quoteEstimator = info.dcValues.quoteEstimator;
                    this.editForm.patchValue({
                        contractProjEstId: info.dcValues.salespersonId
                    });
                }
            });
            //}
            //else { this.doQuoteSearch(this.quoteNumberValue)}
        }
    }
    chkBkChanged(e: any) {
        if (e.target.checked) {
            this.isTMRequired = true;
        } else {
            this.isTMRequired = false;
        }
    }

    cpQuoteValidate(value: any) {

        var skipCheck = false;
        if (!value) {

            this.editForm.patchValue({
                quoteNumber: value,
                quoteId: null
            });
            skipCheck = true;
        }
        else {
            var quoteId = this.editForm.controls["quoteId"].value;
            var quoteNumber = this.editForm.controls["quoteNumber"].value;
            if (quoteId) {
                if (quoteNumber === value) { skipCheck = true }
            }
        }

        if (!skipCheck) {
            this.cpQuoteSearch = false;
            this.quoteNumberValue = value;
            this.CpSearchQuotes.validate(value);
        }

    }
    get showProjectMgr(): boolean {
        return this.isMainJob;
    }
    get notClosed(): boolean {
        let can: boolean = false;
        if (!this.data || !this.data.dispatchStatusId || (this.data.dispatchStatusId != CommonValues.Dispatch_Billed && this.data.dispatchStatusId != CommonValues.Dispatch_Closed) || this.rights.EditClosedDispatch) {
            can = true;
        }
        return can;
    }
    get canAssignTech(): boolean {
        let can: boolean = this.isValid && this.notClosed;
        return can;
    }
    get isMainJob(): boolean {
        return CommonFunctions.hasValue(this.addtlData) ? this.addtlData.isMainJob : false;
    }
    get isPostWarrantyJob(): boolean {
        return this.hasRelatedJobTypeId && this.relatedJobTypeId === CommonValues.RelatedJobType_PostWarranty;
    }
    get isManufacturerWarrantyJob(): boolean {
        return this.hasRelatedJobTypeId && (
            this.relatedJobTypeId === CommonValues.RelatedJobType_ManufacturerWarrantyCarpentry
            || this.relatedJobTypeId === CommonValues.RelatedJobType_ManufacturerWarrantyElectrical
            || this.relatedJobTypeId === CommonValues.RelatedJobType_ManufacturerWarrantyRefrigeration
        );
    }
    get isManufacturerOrPostWarrantyJob(): boolean {
        return this.isManufacturerWarrantyJob || this.isPostWarrantyJob;
    }
    get showInvoiceTab(): boolean {
        return this.isPostWarrantyJob || this.isManufacturerWarrantyJob;
    }
    get showEstimatorFromQuote(): boolean {
        return !this.isManufacturerOrPostWarrantyJob;
    }
    relJobTypeCBOChanged(item: GGItem) {
        console.log("job-reljtch: ", item);
        if (CommonFunctions.hasValue(item) && this.hasAddtlData) {
            this.addtlData.isMainJob = item.flag;
            this.checkAndSetChangeOrder();
            this.matchAccountClass(item.value);
        }
    }
    accountClassCBOChanged(item: GGItem) {
        if (CommonFunctions.hasValue(item) && this.hasAddtlData) {
            this.parentJob = null;
            this.checkAndSetChangeOrder();
            this.matchRelJobType(item.value);
        }
    }
    matchRelJobType(actClass: any) {
        switch (actClass.toLowerCase()) {
            case CommonValues.AccountClass_ReferHVACConstruction:	//Refer / HVAC Construction
                if (this.editForm.value.relatedJobTypeId !== CommonValues.RelatedJobType_RefrigerationJob && this.editForm.value.relatedJobTypeId !== CommonValues.RelatedJobType_ChangeOrder) {
                    this.editForm.patchValue({
                        relatedJobTypeId: null
                    });
                }
                break;
            case CommonValues.AccountClass_ElectricalConstruction:	//Electrical Construction
                if (this.editForm.value.relatedJobTypeId !== CommonValues.RelatedJobType_ElectricalJob && this.editForm.value.relatedJobTypeId !== CommonValues.RelatedJobType_ChangeOrder) {
                    this.editForm.patchValue({
                        relatedJobTypeId: null
                    });
                }
                break;
            case CommonValues.AccountClass_CarpentryConstruction:	//Carpentry Construction
                if (this.editForm.value.relatedJobTypeId !== CommonValues.RelatedJobType_CarpentryJob && this.editForm.value.relatedJobTypeId !== CommonValues.RelatedJobType_ChangeOrder) {
                    this.editForm.patchValue({
                        relatedJobTypeId: null
                    });
                }
                break;
            case CommonValues.AccountClass_MgmtConstruction:	//Mgmt Construction
                if (this.editForm.value.relatedJobTypeId !== CommonValues.RelatedJobType_ManagementJob && this.editForm.value.relatedJobTypeId !== CommonValues.RelatedJobType_ChangeOrder) {
                    this.editForm.patchValue({
                        relatedJobTypeId: null
                    });
                }
                break;
            case CommonValues.AccountClass_EMSConstruction:	//EMS Construction
                if (this.editForm.value.relatedJobTypeId !== CommonValues.RelatedJobType_EMSJob && this.editForm.value.relatedJobTypeId !== CommonValues.RelatedJobType_ChangeOrder) {
                    this.editForm.patchValue({
                        relatedJobTypeId: null
                    });
                }
                break;
            case CommonValues.AccountClass_HVACConstruction:	//HVAC Construction
                if (this.editForm.value.relatedJobTypeId !== CommonValues.RelatedJobType_HVACJob && this.editForm.value.relatedJobTypeId !== CommonValues.RelatedJobType_ChangeOrder) {
                    this.editForm.patchValue({
                        relatedJobTypeId: null
                    });
                }
                break;
            case CommonValues.AccountClass_GCConstruction:	//GC Construction
                if (this.editForm.value.relatedJobTypeId !== CommonValues.RelatedJobType_GCJob && this.editForm.value.relatedJobTypeId !== CommonValues.RelatedJobType_ChangeOrder) {
                    this.editForm.patchValue({
                        relatedJobTypeId: null
                    });
                }
                break;
            case CommonValues.AccountClass_EquipmentSales:	//Equipment Sales
                if (this.editForm.value.relatedJobTypeId !== CommonValues.RelatedJobType_EquipmentSales && this.editForm.value.relatedJobTypeId !== CommonValues.RelatedJobType_ChangeOrder) {
                    this.editForm.patchValue({
                        relatedJobTypeId: null
                    });
                }
                break;
            case CommonValues.AccountClass_PlumbingConstruction:	//Plumbing Construction
                if (this.editForm.value.relatedJobTypeId !== CommonValues.RelatedJobType_PlumbingJob && this.editForm.value.relatedJobTypeId !== CommonValues.RelatedJobType_ChangeOrder) {
                    this.editForm.patchValue({
                        relatedJobTypeId: null
                    });
                }
                break;
            case CommonValues.AccountClass_WarrantyConstruction:	//Warranty Construction
                if (this.editForm.value.relatedJobTypeId !== CommonValues.RelatedJobType_PostWarranty && this.editForm.value.relatedJobTypeId !== CommonValues.RelatedJobType_ChangeOrder) {
                    this.editForm.patchValue({
                        relatedJobTypeId: null
                    });
                }
                break;
            case CommonValues.AccountClass_WarrantyMFG:	//MFG Warranty Construction
                if (this.editForm.value.relatedJobTypeId !== CommonValues.RelatedJobType_MfgWarrantyRef && this.editForm.value.relatedJobTypeId !== CommonValues.RelatedJobType_ChangeOrder) {
                    this.editForm.patchValue({
                        relatedJobTypeId: null
                    });
                }
                break;
            case CommonValues.AccountClass_ReferService:	//Main Service Types
                if (this.editForm.value.relatedJobTypeId !== CommonValues.RelatedJobType_ChangeOrder) {
                    this.editForm.patchValue({
                        relatedJobTypeId: null
                    });
                }
                break;
            case CommonValues.AccountClass_HVACService:	//Main Service Types
                if (this.editForm.value.relatedJobTypeId !== CommonValues.RelatedJobType_ChangeOrder) {
                    this.editForm.patchValue({
                        relatedJobTypeId: null
                    });
                }
                break;
            case CommonValues.AccountClass_CarpentryService:	//Main Service Types
                if (this.editForm.value.relatedJobTypeId !== CommonValues.RelatedJobType_ChangeOrder) {
                    this.editForm.patchValue({
                        relatedJobTypeId: null
                    });
                }
                break;
            case CommonValues.AccountClass_ElectricalService:	//Main Service Types
                if (this.editForm.value.relatedJobTypeId !== CommonValues.RelatedJobType_ChangeOrder) {
                    this.editForm.patchValue({
                        relatedJobTypeId: null
                    });
                }
                break;
            case CommonValues.AccountClass_EnergyManagementServices:
                if (this.editForm.value.relatedJobTypeId !== CommonValues.RelatedJobType_EnergyManagementServicesJob && this.editForm.value.relatedJobTypeId !== CommonValues.RelatedJobType_ChangeOrder) {
                    this.editForm.patchValue({
                        relatedJobTypeId: null
                    });
                }
                break;
            case CommonValues.AccountClass_EnergyManagementServicesSub:
                if (this.editForm.value.relatedJobTypeId !== CommonValues.RelatedJobType_EnergyManagementServicesSubJob && this.editForm.value.relatedJobTypeId !== CommonValues.RelatedJobType_ChangeOrder) {
                    this.editForm.patchValue({
                        relatedJobTypeId: null
                    });
                }
                break;
        }
    }
    matchAccountClass(jobType: any) {
        switch (jobType.toLowerCase()) {
            case CommonValues.RelatedJobType_RefrigerationJob:	//Refer / HVAC Construction
                if (this.editForm.value.accountClassId !== CommonValues.AccountClass_ReferHVACConstruction) {
                    this.editForm.patchValue({
                        accountClassId: null
                    });
                }
                break;
            case CommonValues.RelatedJobType_ElectricalJob:	//Electrical Construction
                if (this.editForm.value.accountClassId !== CommonValues.AccountClass_ElectricalConstruction) {
                    this.editForm.patchValue({
                        accountClassId: null
                    });
                }
                break;
            case CommonValues.RelatedJobType_CarpentryJob:	//Carpentry Construction
                if (this.editForm.value.accountClassId !== CommonValues.AccountClass_CarpentryConstruction) {
                    this.editForm.patchValue({
                        accountClassId: null
                    });
                }
                break;
            case CommonValues.RelatedJobType_ManagementJob:	//Mgmt Construction
                if (this.editForm.value.accountClassId !== CommonValues.AccountClass_MgmtConstruction) {
                    this.editForm.patchValue({
                        accountClassId: null
                    });
                }
                break;
            case CommonValues.RelatedJobType_EMSJob:	//EMS Construction
                if (this.editForm.value.accountClassId !== CommonValues.AccountClass_EMSConstruction) {
                    this.editForm.patchValue({
                        accountClassId: null
                    });
                }
                break;
            case CommonValues.RelatedJobType_HVACJob:	//HVAC Construction
                if (this.editForm.value.accountClassId !== CommonValues.AccountClass_HVACConstruction) {
                    this.editForm.patchValue({
                        accountClassId: null
                    });
                }
                break;
            case CommonValues.RelatedJobType_GCJob:	//GC Construction
                if (this.editForm.value.accountClassId !== CommonValues.AccountClass_GCConstruction) {
                    this.editForm.patchValue({
                        accountClassId: null
                    });
                }
                break;
            case CommonValues.RelatedJobType_EquipmentSales:	//Equipment Sales
                if (this.editForm.value.accountClassId !== CommonValues.AccountClass_EquipmentSales) {
                    this.editForm.patchValue({
                        accountClassId: null
                    });
                }
                break;
            case CommonValues.RelatedJobType_PlumbingJob:	//Plumbing Construction
                if (this.editForm.value.accountClassId !== CommonValues.AccountClass_PlumbingConstruction) {
                    this.editForm.patchValue({
                        accountClassId: null
                    });
                }
                break;
            case CommonValues.RelatedJobType_PostWarranty:	//Warranty Construction
                if (this.editForm.value.accountClassId !== CommonValues.AccountClass_WarrantyConstruction) {
                    this.editForm.patchValue({
                        accountClassId: null
                    });
                }
                break;
            case CommonValues.RelatedJobType_MfgWarrantyRef:	//MFG Warranty Construction
                if (this.editForm.value.accountClassId !== CommonValues.AccountClass_WarrantyMFG) {
                    this.editForm.patchValue({
                        accountClassId: null
                    });
                }
                break;
            case CommonValues.RelatedJobType_EnergyManagementServicesJob:
                if (this.editForm.value.accountClassId !== CommonValues.AccountClass_EnergyManagementServices) {
                    this.editForm.patchValue({
                        accountClassId: null
                    });
                }
                break;
            case CommonValues.RelatedJobType_EnergyManagementServicesSubJob:
                if (this.editForm.value.accountClassId !== CommonValues.AccountClass_EnergyManagementServicesSub) {
                    this.editForm.patchValue({
                        accountClassId: null
                    });
                }
                break;
        }
    }
    get jobReadOnly(): boolean {
        return this.readOnly || !this.hasMasterId;
    }
    parentJob: CnstJobBus;
    get hasParentJob(): boolean {
        return CommonFunctions.hasValue(this.parentJob);
    }
    get selectedAccountClassId(): any {
        return this.acctClassComp && CommonFunctions.hasValue(this.acctClassComp.value)
            ? this.acctClassComp.value
            : this.accountClassId;
    }
    getRelatedAccountClassIds() {
        if (this.hasMasterId && this.isChangeOrder) {
            CommonFunctions.unsubscribe(this.subs_getContractInfoOnly);
            this.subs_getContractInfoOnly = this.svc_cnst.getContractInfoOnly(this.masterId).subscribe((info: BaseMessageInfo) => {
                if (!info.saveError) {
                    let contract: CnstContractBus = new CnstContractBus(info.primaryReturn);
                    this.relatedAccountClassIds = CommonFunctions.hasArrayElementValue(contract.relatedJobs)
                        ? contract.relatedJobs.map((job: RelatedJobBus) => job.accountClassId)
                        : [];
                }
            });
        }
    }
    checkAndSetChangeOrder() {
        if (this.isChangeOrder) {
            const selectedAccountClassId: any = this.selectedAccountClassId;
            if (this.compFeatureFlagSet.featureFlagSet['ui-restrict-co-class-if-no-main-trade-for-that-class-exists']) {
                this.mainTradeJob = CommonFunctions.hasValue(selectedAccountClassId)
                    && this.mainTradeJobClasses.includes(selectedAccountClassId.toLowerCase());

                if (this.mainTradeJob) {
                    this.noMainJobForChangeOrder = !this.relatedAccountClassIds.includes(selectedAccountClassId);

                    if (this.noMainJobForChangeOrder) {
                        let acctClassText: string = this.hasAcctClassText ? this.acctClassComp.text : "";
                        this.cnfShowSomeGeneralMessage("You cannot create a Change Order because the main job " + acctClassText + " has not been created.", "Cannot Create Change Order");
                        this.editForm.patchValue({ accountClassId: null });
                    }
                } else {
                    this.noMainJobForChangeOrder = false;
                }
            } else {
                this.mainTradeJob = false;
                this.noMainJobForChangeOrder = false;
            }

            if (!this.hasParentJob && CommonFunctions.hasGuidValue(selectedAccountClassId) && this.hasMasterId) {
                CommonFunctions.unsubscribe(this.subs_checkAndSetChangeOrder);
                this.subs_checkAndSetChangeOrder = this.svc_cnst.getChangeOrderParentJob(this.masterId, selectedAccountClassId).subscribe((info: BaseMessageInfo) => {
                    if (!info.saveError) {
                        this.parentJob = new CnstJobBus(info.primaryReturn);
                    }
                });
            }
        }

        this.setProjectManagerValidity();
    }
    tryCreateInvoice() {
        this.compLoader.cpLoaderOn(true);
        let param: DQOIMessageInfo = new DQOIMessageInfo();
        param.fromSearchTarget = SearchTarget.job;
        param.toSearchTarget = SearchTarget.invoice;
        param.fromId = this.id;
        CommonFunctions.unsubscribe(this.subs_tryCreateInvoice);
        this.subs_tryCreateInvoice = this.svc_dqoi.canCreate(param).subscribe((info: DQOIMessageInfo) => {
            if (info.canCreate) {
                //set tab with code
                this.createInvoice();

                //  let index = this.getTabIndexFromTarget(toSearchTarget);
                //  this.selectingTabProgramatically = true;
                //  this.tabstrip.selectTab(index);
            }
            else {
                this.compLoader.cpLoaderOff();
                if (CommonFunctions.hasStringValue(info.message)) {
                    this.cnfShowSomeGeneralMessage(info.message, "Cannot Create Invoice");
                }
            }
        });

    }
    createInvoice() {
        this.compLoader.cpLoaderOn(true);
        CommonFunctions.unsubscribe(this.subs_createInvoice);
        this.subs_createInvoice = this.svc_dqoi.createNewInvoiceFrom(SearchTarget.job, this.id).subscribe((info: InvoiceMessageInfo) => {
            this.compLoader.cpLoaderOff();
            if (!info.saveError) {
                this.goTo(info, SearchTarget.invoice, "CRFROMJOB");
            }
        });
    }
    checkAccountClassIsValid(statusId) {
        if (this.hasAccountClassId) {
            let availAcctClasses: GGItem[] = (statusId == CommonValues.Dispatch_ForConstructionReview && this.referenceData) ? this.referenceData.accountClasses : this.referenceData.accountClassesConstruction;

            if (availAcctClasses.map(item => item.value).indexOf(this.accountClassId) == -1) {
                this.editForm.patchValue({
                    accountClassId: null
                });
            }
        }
    }
    statusCBOChanged(item: GItem) {
        if (item.value === CommonValues.Dispatch_Billed || item.value === CommonValues.Dispatch_Canceled || item.value === CommonValues.Dispatch_Closed) {

            this.svc_cnst.checkJobStatusChange(this.id, item.value).subscribe((info: CnstMessageInfo) => {
                if (info.closeOutResourceWarning === true) {
                    this.cnfDialog.show(info.message, CRUDActions.Update, info.primaryReturn, "Currently Assigned Resources", "CMPRES");
                }
            });
        } else if ((this.data.dispatchStatusId === CommonValues.Dispatch_ForConstructionReview) && !this.hasPermission) {
            let title: string = "Status Change";
            this.cnfShowSomeGeneralMessage(" You do not have permissions to change the status from - For Construction Review. Please email construction - admin@climatepros.com to have your dispatch returned.", title);
            this.patchStatus(this.data.dispatchStatusId);
        }

        else {
            this.patchCloseoutResources(false, null);
        }

        this.checkAccountClassIsValid(item.value);
    }
    confirmCustom(data: ConfirmOutput) {
        if (data.dialogResult === CPDialogResult.ok && data.code === "CMPRES") {
            this.patchCloseoutResources(true, this.statusId);
        }
    }
    patchCloseoutResources(closeOutResources: boolean, statusId: any) {
        this.editForm.patchValue({
            closeOutResources: closeOutResources,
            closeOutResourcesStatusId: statusId
        });

    }

    patchStatus(statusId: any) {
        this.editForm.patchValue({
            dispatchStatusId: statusId
        });

    }
    gotoInvoice(id: any) {
        if (CommonFunctions.hasValue(id)) {
            this.goTo(id, SearchTarget.invoice);
        }
    }
    assignTech(personToAssignId: any = null) {
        let dataObj: DispatchItemBus = new DispatchItemBus();
        dataObj.dispatchId = this.data.dispatchId;
        dataObj.dispatchNumber = this.data.dispatchNumber;
        dataObj.locationId = this.data.locationId;
        dataObj.customerId = this.data.customerId;
        dataObj.personToAssignId = personToAssignId;
        dataObj.from = SearchTarget.job;
        if (!this.hasId || this.isDirty) {
            this.setAfterSaveMessage({ messageType: MessageType.assignNewTech, value: personToAssignId, values: personToAssignId, messageSubject: null, message: null, dqoiIndex: null, searchTarget: SearchTarget.any, refreshTarget: null });
            this.save();
        }
        else {
            this.cpPopWindow({ contentType: WindowContents.assignTech, boardData: { assignDispatch: dataObj } });
        }
    }

    scheduleDispatchesActive: boolean = false;
    scheduleDispatchesClosed(e: any) {
        this.scheduleDispatchesActive = false;
    }
    scheduleDispatches() {
        this.scheduleDispatchesComponent.setup(null);
        this.scheduleDispatchesActive = true;
    }

    test() {
        console.log("job-test:", this, this.editForm);
        //let item: DQOIItem = this.svc_dqoi.getDQOIItem(this.dqoiIndex);
        //let itemBus: DQOIItem = new DQOIItem(item);

        //this.getListFromMaster();
        //            let grpmasterList: GroupResult[] = groupBy(this.rawMasterList, [{ field: "relatedJobType" }])
        ////            let grpmasterList: GroupResult[] = groupBy(this.rawMasterList, [{ field: "category" }])
        //            this.masterList = grpmasterList;

    }
    onCPWindowClosed(e) {
        this.refreshData(DbTable.DispatchAssignments);
        super.onCPWindowClosed(e);
    }
    refreshDQOI() {
        this.refresh();
    }
    refreshData(refreshTarget: DbTable) {
        if (!CommonFunctions.hasValue(refreshTarget)) {
            super.refreshData(null);
        }
        else {
            switch (refreshTarget) {
                case DbTable.DispatchAssignments:
                    this.pageData.getAssignments(this.data.dispatchId, this.referenceData);
                    break;
            }
        }
        let index: number = -1;
        this.subTab.tabs.forEach((tab: TabStripTabComponent) => {
            index++;
            if (tab.selected === true) {
                var event: SelectEvent = new SelectEvent(index, tab.title);
                this.onTabSelect(event);
            }

        });
        //
    }

    override customParentMessage(e: Message) {
        if (e.messageType === MessageType.assignNewTech) {
            this.assignTech(null);
        }
        else if (e.messageType === MessageType.reassignTech) {
            this.assignTech(e.values);
        }
    }
    public iconClass: string = 'fas fa-file-plus';
    public orderTypeData: Array<any> = [
        {
            text: 'Order',
            iconClass: 'fa fa-shopping-cart'
        }, {
            text: 'Sub-PO',
            iconClass: 'fa fa-user'
        }];

    public onAddOrderSplitButtonClick(e: string): void {
        if (e === "Order") {
            this.createOrderFromJob(this.id, false);
        }
        else {
            this.createOrderFromJob(this.id, true);
        }
    }
    createOrderFromJob(jobId: any, isSubPO: boolean) {
        //if (this.editForm) {
        //    this.saveCurrent();
        //}
        if (this.statusId == CommonValues.Dispatch_Billed || this.statusId == CommonValues.Dispatch_Closed || this.statusId == CommonValues.Dispatch_Canceled || this.statusId == CommonValues.Dispatch_Merged) {
            //this.mainLoadingOff(true);
            this.miShow("You cannot create an order on a Job that is in Billed/Closed/Cancelled/Merged Status", null, "Cannot Save Message");
        }
        else {
            let param: CommonParam = new CommonParam();
            param.addParam("jobId", jobId);
            param.addParam("isSubPO", isSubPO);
            let msg: Message = new Message();
            msg.messageType = MessageType.createOrderFromJob;
            msg.messageSubject = null;
            msg.message = null;
            msg.values = null;
            msg.value = param;
            this.parentMessage(msg, this.compLoader);
        }
    }
    get showActionOnQuote(): boolean {
        return this.hasQuoteId ? this.rights.ViewQuotes : this.rights.MaintainQuotes;
    }
    doAction(param: CommonParam) {
        let action: string = param.getParam("ACTION");
        let code: string = param.getParam("CODE");
        let id: any = param.getParam("ID");
        switch (action.toUpperCase()) {
            case "GETPAGEDATA":
                this.pageData.getData(id, code);
                break;
        }
    }
    get emailTitle(): string {
        return this.hasId && this.customerId === CommonValues.Customer_WalMart ? 'WalMart Email' : 'Email';
    }
    get canEmail(): boolean {
        return this.hasId; //this.serviceMode !== '1';
    }
    email() {
        //CPM 02/23/22: Construction does not need a different email for Wal-Mart
        if (this.customerId === CommonValues.Customer_WalMart && false) {
            this.svc_data.getWalMartEmail(this.id).subscribe((info: BaseMessageInfo) => {
                if (!info.saveError) {
                    let email: Email = new Email(info.primaryReturn);
                    window.location.assign("mailto: ?subject=" + email.subjectEncoded() + "&body=" + email.bodyEncoded());
                }
                else {
                    this.saveError("Error Trying to Construct Email: " + info.message);
                }
            });
        }
        else {
            this.svc_data.getEmailDefaultsForDispatch(this.id).subscribe((info: BaseMessageInfo) => {
                if (!info.saveError) {
                    let email: Email = new Email(info.primaryReturn);
                    window.location.assign("mailto: ?subject=" + email.subjectEncoded() + "&body=" + email.bodyEncoded());
                } else {
                    this.saveError("Error Trying to Construct Email: " + info.message);
                }
            });
        }
    }

    public maxCharLimit: number = 50;
    public characterCount: number = 0;
    public charCounter = `${this.characterCount}/${this.maxCharLimit}`;

    characterCounter(ev) {
        this.characterCount = ev ? ev.length : 0;

        this.charCounter = `${this.characterCount}/${this.maxCharLimit}`;
    }

    setProjectManagerValidity() {
        if (!this.showProjectMgr) {
            this.editForm.controls["contractProjAdminId"].clearValidators();
        } else { this.editForm.controls["contractProjAdminId"].setValidators([Validators.required]); }
        this.editForm.controls["contractProjAdminId"].updateValueAndValidity();
    }
}

/*****************************************************************
 * [GRG-20200604] remove foremanId as required
 *  not required at setup may need to require at some stage
 *
 * *****************************************************************/
